import { Button, Input, TextField } from '@mui/material';
import React, { useState } from 'react';

const AddDoctor = () => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [image, setImage] = useState(null);
    const [success, setSuccess] = useState(false);


    const handleSubmit = (e) => {
        e.preventDefault();
        if (!image) {
            return
        }
        const formData = new FormData();
        formData.append('name', name);
        formData.append('email', email);
        formData.append('image', image);

        fetch('https://salty-scrubland-74088.herokuapp.com/doctors', {
            method: 'POST', // or 'PUT' 
            body: formData
        })
            .then(response => response.json())
            .then(data => {
                if (data.insertedId) {
                    setSuccess('Doctor added successfully');
                    console.log('Doctor added successfully');
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
    return (
        <div>
            <h2>AddDoctor</h2>
            <form onSubmit={ handleSubmit }>
                <TextField sx={ { width: '50%' } }
                    label="Name"
                    type="text"
                    required
                    variant="standard"
                    onChange={ e => setName(e.target.value) }
                /> <br />
                <TextField sx={ { width: '50%' } }
                    label="Email"
                    type="email"
                    required
                    onChange={ e => setEmail(e.target.value) }
                    variant="standard"

                /><br />
                <Input
                    accept="image/*"
                    multiple
                    type="file"
                    onChange={ e => setImage(e.target.files[0]) }
                /><br />
                <Button variant="contained" type="submit">
                    Upload
                </Button>
            </form>
            {
                success && <p color="green">{ success }</p>
            }
        </div>
    );
};

export default AddDoctor;